import { useMemo } from 'react';
import axios from 'axios';
import { getApiBaseUrl } from '../../lib/utils';
import { useAuth } from '../../context/AuthContext';

// In Admin preview, the X-Acting-As header names the council seat an admin is testing as.
export function useCouncilApi(actingAs) {
  const { getToken } = useAuth();
  return useMemo(() => {
    const url = (path) => `${getApiBaseUrl()}/api/council${path}`;
    const headers = () => ({ Authorization: `Bearer ${getToken()}`, ...(actingAs ? { 'X-Acting-As': actingAs } : {}) });
    return {
      get: (path, params) => axios.get(url(path), { headers: headers(), ...(params ? { params } : {}) }),
      post: (path, body) => axios.post(url(path), body || {}, { headers: headers() }),
      put: (path, body) => axios.put(url(path), body || {}, { headers: headers() }),
      del: (path) => axios.delete(url(path), { headers: headers() }),
      download: (path) => axios.get(url(path), { headers: headers(), responseType: 'blob' })
    };
  }, [getToken, actingAs]);
}

export const ACTING_AS_KEY = (slug) => `council-acting-as:${slug}`;
